import api from ".";
import cookiesModifier from "../utils/cookies";

import { ISaveNotificationParameter } from "../types/custom_notifications";


export const saveNotificationParameter = async (data: ISaveNotificationParameter) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`/notification-parameters`, data);
        return res.status;
    } catch (error) {
        throw error;
    }
};

export const deleteNotificationParameter = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`/notification-parameters/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
};